export { TicketDetailsComponent } from "./ticket-details.component"
